import { Component, Inject, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { UserService } from '../../services';
import { LoadingIndicatorComponent } from '../../../../features/core/components';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [LoadingIndicatorComponent, NgIf]
})
export class LoginComponent implements OnInit {
  buildversion?: string;
  appname?: string;
  isLoading: boolean = true;

  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth
    , private router: Router
    , @Inject('CONFIG_SETTINGS') config: any
    , private userService: UserService) {
    const configSettings = config['appbuild'];
    this.buildversion = configSettings['version'];
    this.appname = configSettings['name'];
  }

  async ngOnInit() {
    // Initially show loading indicator while checking authentication
    this.isLoading = true;
    try {
      // Add a small delay to ensure loader is visible
      await new Promise(resolve => setTimeout(resolve, 1000));

      // check if the user is already authenticated.
      // if so route them to the home page

      const isAuthenticated = await this.oktaAuth.isAuthenticated();


      if (isAuthenticated) {

        this.router.navigate(['home']);
        return;
      }
    } catch (error) {
      console.error('Error checking authentication:', error);
    }

    // If not authenticated, hide loading and show login UI
    this.isLoading = false;
  }

  login() {
    this.oktaAuth.signInWithRedirect();
  }
}
